<template>
  <div>
      <div class="container-fluid" v-if="hasError">
        <div class="row">
          <div class="col-sm-12">
            <h5 class="mb-0">
              Hubo un problema al procesar tu compra, por favor revisa los detalles a continuación eh intentalo de nuevo
            </h5>
            <p>
              {{hasError.Error}}
            </p>
          </div>
        </div>
      </div>
      <div class="container-fluid" v-else>
        <div class="row">
            <div class="col-sm-12 text-center mb-4">
              <h4 class="mb-0">
                Gracías por tu compra, ahora eres parte de  la Comunidad Hispano Club
              </h4>
              <small>
                Comienza a utilizar tu Membresía y mejora tu estilo de vida
              </small>
            </div>
          </div>
        <!-- Cuenta hispano  -->
        <div class="row">
          <div class="col-md-12">
            <h5 class="mb-0">
                Cuenta Hispano Club
            </h5>
          </div>
        </div>
        <div class="row align-items-center mb-4">
            <div class="col-md-8">
              <dl class="row mb-0">
                <dt class="col-sm-4"><span>Usuario</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.email}}</dd>
                <dt class="col-sm-4"><span>Contraseña</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.password}}</dd>
              </dl>
            </div>
        </div>
        <!-- / Cuenta hispano  -->
        <!-- Producto -->
        <div class="row mb-4" v-if="saleObject">
            <div class="col-md-8">
            <h5 class="mb-2">
                Membresía Hispano Club {{itemdata.title}}
                <!-- {{itemdata.subtitle}} -->
            </h5>
            <dl class="row mb-4" style=" font-size:  0.8rem; ">
              <dt class="col-sm-4"><span>Membresía: </span></dt>
                <dd class="col-sm-8 mb-0">{{saleObject.cards[0].card_membership}}</dd>

                <dt class="col-sm-4 "  v-if="finalModel.add_kit"><span>Tu ID : </span></dt>
                <dd class="col-sm-8 mb-0 h6"  v-if="finalModel.add_kit">
                  {{saleObject.netzenId}}
                </dd>
            </dl>
            <dl class="row mb-0" style=" font-size:  0.8rem; ">
                <dt class="col-sm-4" v-if="saleObject.cards[0].membershipNextPayment">
                  <span>Prox. Pago</span>
                </dt>
                <dd class="col-sm-8 mb-0" v-if="saleObject.cards[0].membershipNextPayment">
                  {{saleObject.cards[0].membershipNextPayment}}
                </dd>

                <dt class="col-sm-4"><span>Titular</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.first_name}} {{finalModel.last_name}}</dd>
                <dt class="col-sm-4"><span>Email</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.email}}</dd>
                <dt class="col-sm-4"><span>Cumpleaños</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.birthdate}}</dd>
                <dt class="col-sm-4"><span>Celular</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.mobile_phone}}</dd>
                <dt class="col-sm-4"><span>Dirección</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.address_1}} {{finalModel.address_2}}</dd>
                <dt class="col-sm-4"><span>Ciudad</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.city}}</dd>
                <dt class="col-sm-4"><span>Estado</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.state}}</dd>
                <dt class="col-sm-4"><span>ZIP</span></dt>
                <dd class="col-sm-8 mb-0">{{finalModel.postcode}}</dd>
                <dt class="col-sm-4" v-if="finalModel.seller_id">
                  <span>ID de tu Patrocinador</span>
                </dt>
                <dd class="col-sm-8 mb-0" v-if="finalModel.seller_id">
                  {{finalModel.seller_id}}
                </dd>
              </dl>
            </div>
            <div class="col-md-4 text-right">
            <h5>{{ itemdata.price | currency }} / {{itemdata.period}}</h5>
            </div>
        </div>
        <!-- / Producto -->
        <!-- Add Kit -->
        <div class="row mb-4" v-if="finalModel.add_kit">
            <div class="col-md-8">
              <h5 class="mb-2">
                  Se añadio el Kit de Socio Hispano Club
                  <!-- {{itemdata.subtitle}} -->
              </h5>
            </div>
        </div>
        <fade-transition>
        <div class="row" v-if="finalModel.add_kit">
            <div class="col-md-8">
            <span>{{kitSocio.name}}</span>
            </div>
            <div class="col-md-4 text-right">
                {{ kitSocio.cost | currency }}
            </div>
        </div>
        </fade-transition>
        <fade-transition>
        <div class="row mb-4" v-if="finalModel.add_kit">
            <div class="col-md-8">
            <span>Costo de envio</span>
            </div>
            <div class="col-md-4 text-right">
                {{ kitSocio.ship | currency }}
            </div>
        </div>
        </fade-transition>
        <!-- / Add Kit -->

        <div class="row">
            <div class="col-sm-12">
            <hr>
            </div>
        </div>
        <!-- total -->
        <div class="row mb-4">
            <div class="col-md-8">
            <h4 class="mb-2">
                Total Pagado
            </h4>
            </div>
            <div class="col-md-4 text-right">
            <h4>
              {{finalModel.price | currency}}
            </h4>
            </div>
        </div>
        <!-- / total -->
      </div>
  </div>
</template>

<script>
// eslint-disable-next-line
import successSale from '@/mock/successSale'
// eslint-disable-next-line
import finalObject from '@/mock/finalObject'
// eslint-disable-next-line
import { validationMixin } from 'vuelidate'
// eslint-disable-next-line
import { required, minLength, maxLength, email, sameAs} from 'vuelidate/lib/validators'
export default {
  name: 'FormStepFinal',
  props: [
    'saleObject',
    'hasError',
    'finalModel',
    'itemdata'
  ],
  data () {
    return {
      kitSocio: {
        name: 'Kit de Socio Hispano Club',
        cost: 55,
        ship: 10
      }
      // saleObject: successSale.success
      /* finalModel: finalObject.final */
    }
  },
  computed: {
    isSelling () {
      return this.$store.state.isSelling.process
    },
    isSellingIndex () {
      return this.$store.state.isSelling.index
    },
    statusForm () {
      return this.$v.user.$invalid
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/FormStepFinal.vue